export default __webpack_public_path__ + "static/media/22_1_1.44dc03e0.png";